
import { IModel, Model, ModelRecord } from "./Model";
import { VisitReferralRecommendationModel } from "@common/models/VisitReferralRecommendationModel";

export interface IVisitReferralModel extends IModel {
    visitReferralId: number;
    visitId: number;
    assessmentReferralId: number;   
    isReferred: boolean;
    assessmentReferralName: string;    
    assessmentReferralDescription: string;
    assessmentReferralSortOrder: number;   
    assessmentReferralAttachmentStorageContentId: number | undefined;
    recommendations: VisitReferralRecommendationModel[];
}

export class VisitReferralModel extends Model implements ModelRecord<IVisitReferralModel> {
   
    visitReferralId: number;
    visitId: number;
    assessmentReferralId: number;   
    isReferred: boolean;
    assessmentReferralName: string;    
    assessmentReferralDescription: string;
    assessmentReferralSortOrder: number;   
    assessmentReferralAttachmentStorageContentId: number | undefined;
    recommendations: VisitReferralRecommendationModel[];

    constructor(params: Partial<IVisitReferralModel>) {
        super(params);
        this.visitReferralId = params.visitReferralId ?? 0;
        this.visitId = params.visitId ?? 0;
        this.assessmentReferralId = params.assessmentReferralId ?? 0;
        this.isReferred = _.defaultTo(params.isReferred, false);
        this.assessmentReferralName =  params.assessmentReferralName ??'';
        this.assessmentReferralDescription =  params.assessmentReferralDescription ??'';
        this.assessmentReferralSortOrder =  params.visitReferralId ?? 0;
        this.assessmentReferralAttachmentStorageContentId = params.assessmentReferralAttachmentStorageContentId ?? 0;
        this.recommendations = params.recommendations ??[];       
    }
   
}
